module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REFACE")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("With "), _c('em', [_vm._v("God’s Heirs")]), _vm._v(" we present the seventh volume of Dr. Barnhouse’s exposition of the Epistle to the Romans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Several years ago Dr. Barnhouse asked a number of outstanding Bible teachers and preachers what their favorite chapter in the Bible was. Realizing that needs differ at different times of life, and that this choice was something like asking a father to choose his favorite child, nevertheless Dr. Barnhouse posed this situation: If each of them were to be wrecked on a desert island, and if there were to be but a single chapter of the Bible washed up in the wreckage, what chapter would they like it to be? Five out of the twenty who replied chose the eighth chapter of Romans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Dr. Barnhouse himself chose Romans 8 as his favorite chapter. His reason was that it clearly sets forth God’s complete remedy in Christ for man’s complete ruin in sin. Not only did this chapter set before him the fact that he was redeemed, but that he was a child and heir of God. Furthermore, he rejoiced in the fact that nothing could come between him and his Savior. In Christ and in God he was safe forever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is our hope that those who read these pages will come to this same realization, that they are children of God through Christ Jesus, and as children His heirs, never to be separated from Him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I take this opportunity to express my thanks to my colleague the Rev. Herbert Henry Ehrenstein, who carefully edited the text, and to Miss Olive DeGolia, who prepared the text for publication.")]), _vm._v(" "), _c('p', {
    staticClass: "para-r"
  }, [_c('em', [_vm._v("—Ralph L. Keiper")])])]), _c('p', {
    staticClass: "para-r0"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('em', [_vm._v("Director of Research, Evangelical Foundation")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-437b4e56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Preface.vue
// module id = 72
// module chunks = 0